import { lazy, Suspense } from "react";
import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { ConnectWithUs } from "@/components/home/ConnectWithUs";
import { JsonLd } from "@/components/seo/JsonLd";
import { useSiteSettings } from "@/hooks/useSiteSettings";

// Lazy load below-fold sections to improve TTI
const ServicesSection = lazy(() => import("@/components/home/ServicesSection").then(m => ({ default: m.ServicesSection })));
const FeaturedVideosSection = lazy(() => import("@/components/home/FeaturedVideosSection").then(m => ({ default: m.FeaturedVideosSection })));
const VerticalVideosSection = lazy(() => import("@/components/home/VerticalVideosSection").then(m => ({ default: m.VerticalVideosSection })));

const TestimonialsSection = lazy(() => import("@/components/home/TestimonialsSection").then(m => ({ default: m.TestimonialsSection })));





// Minimal skeleton for lazy sections
const SectionSkeleton = () => (
  <div className="py-16 flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const Index = () => {
  const { settings: siteSettings } = useSiteSettings();

  return (
    <Layout hasHero>
      <JsonLd />
      <HeroSection />
      <Suspense fallback={<SectionSkeleton />}>
        <ServicesSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton />}>
        <FeaturedVideosSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton />}>
        <VerticalVideosSection />
      </Suspense>
      {siteSettings.showTestimonials && (
        <Suspense fallback={<SectionSkeleton />}>
          <TestimonialsSection />
        </Suspense>
      )}
      <ConnectWithUs />
    </Layout>
  );
};

export default Index;
